angular.module("eCareVault.common.menuOptions", []);
